import $ from 'jquery';

const init = () => {
    $('.human_model__wrapper').on('mouseover', function() {
        if (window.innerWidth >= 1229) {
            $(this)
                .addClass('active')
                .siblings()
                .removeClass('active');
        }
    });
};

export default init();
